import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content"]

  preview(event) {
    event.preventDefault()

    const url = event.currentTarget.getAttribute('href')
    const modal = this.modalTarget
    const content = this.contentTarget

    content.innerHTML = `
      <div class="modal-body text-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    `

    $(modal).modal('show')

    fetch(url, {
      method: 'GET',
    })
      .then(response => {
        return response.text()
      })
      .then(html => {
        content.innerHTML = html
      })
      .catch(() => {
        content.innerHTML = `
          <div class="modal-body">
            <div class="alert alert-danger">
              Failed to load version preview.
            </div>
          </div>
        `
      })
  }
}
